import { render, staticRenderFns } from "./modalNuevoTermino.vue?vue&type=template&id=348a7b83&scoped=true"
import script from "./modalNuevoTermino.vue?vue&type=script&lang=js"
export * from "./modalNuevoTermino.vue?vue&type=script&lang=js"
import style0 from "./modalNuevoTermino.vue?vue&type=style&index=0&id=348a7b83&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "348a7b83",
  null
  
)

export default component.exports